import * as React from 'react'
import type { StyleProps } from 'src/types'

import Y_DivideTemplate from '../Y_DivideTemplate/Y_DivideTemplate'

type Props = {
  header: JSX.Element
  body?: JSX.Element
  footer: JSX.Element
} & StyleProps

const ModalTemplate = ({ header, body, footer, style, className, ...props }: Props) => {
  return (
    <Y_DivideTemplate style={style} className={className} {...props}>
      {header}
      {body}
      {footer}
    </Y_DivideTemplate>
  )
}

export default ModalTemplate
